/** Segmentos de rota workspace sujeitos ao bloqueio de acesso */
export const ACCOUNT_BLOCKED_ROUTE_SEGMENTS = [
  'configuracoes',
  'historia',
  'usuarios',
  'agenda',
  'financeiro',
  'atividade',
  'kanban',
  'integracoes',
  'orcamentos',
  'relatorios',
  'clientes'
]

export function parseWorkspaceRouteSegment (path) {
  const match = String(path || '').match(/\/workspace\/\d+\/([^/?]+)/)
  return match ? match[1] : null
}

export function isAccountBlockedRoute (path) {
  const segment = parseWorkspaceRouteSegment(path)
  return segment != null && ACCOUNT_BLOCKED_ROUTE_SEGMENTS.includes(segment)
}

export function isDashboardWorkspaceAction (action) {
  return action === 'enter' || action === 'create'
}
